import { Link } from 'react-router-dom';
import arrowIcon from 'assets/icons/hmButtonArrow.svg';
import classes from './HomeButton.module.scss';


// Кнопка-пилюля из нового макета: подпись и круглая стрелка справа.
// Ведёт внутрь сайта (to), наружу (href) или просто обрабатывает клик.
// shortLabel — подпись для мобильной ширины, если в макете она короче;
// iconOnlyOnMobile — на мобильном остаётся только кружок со стрелкой.
const HomeButton = ({
  children, shortLabel, iconOnlyOnMobile = false, to, href, onClick, theme = 'yellow', className = '',
}) => {
  const content = (
    <>
      <span className={`${classes.label} ${shortLabel ? classes.labelLong : ''}`}>{children}</span>
      {shortLabel && <span className={classes.labelShort}>{shortLabel}</span>}
      <span className={classes.arrow}>
        <img src={arrowIcon} alt="" width="64" height="64" />
      </span>
    </>
  );

  const rootClass = `${classes.btn} ${theme === 'white' ? classes.btnWhite : classes.btnYellow} ${
    iconOnlyOnMobile ? classes.btnIconOnly : ''} ${className}`;

  if (to) {
    return (
      <Link className={rootClass} to={to}>
        {content}
      </Link>
    );
  }

  if (href) {
    return (
      <a className={rootClass} href={href} target="_blank" rel="nofollow noreferrer">
        {content}
      </a>
    );
  }

  return (
    <button type="button" className={rootClass} onClick={onClick}>
      {content}
    </button>
  );
};

export default HomeButton;
